module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/estadao-9b4467137b60bbb78d13aaab2b0270dc.webp";